import { useMemo } from 'react'
import { loadChatPersist } from '@/features/chat/chatPersist'
import { isChatApiConfigured } from '@/config/api/env'
import { useChatThreadSlices } from './useChatThreadSlices'
import { useChatUiSlices } from './useChatUiSlices'

export function useChatPersistedSlices() {
  const persisted = useMemo(() => loadChatPersist(), [])
  return {
    ...useChatUiSlices(persisted),
    ...useChatThreadSlices(persisted),
    chatApiConfigured: isChatApiConfigured(),
  }
}
